import { createContext, useContext } from 'react';
export const OfflineSessionContext = createContext({ offlineReadOnly: false, chatBackendUnavailable: false, userId: null, sessionExpired: false, reconnect: () => {}, revalidate: () => {} });
export const useOfflineSession = () => useContext(OfflineSessionContext);
